<div class="container">
    <img src="../../../assets/images/access-denied.svg" style="width:350px;height: 350px;"/>
    <h1>Access Denied</h1>
</div>